import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { EquipmentService } from '../_services';
import * as EquipmentActions from '../_actions/equipment';

@Injectable({
  providedIn: 'root',
})
export class EquipmentEffects {
  loadEquipments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EquipmentActions.loadEquipments),
      mergeMap(() =>
        this.equipmentService.getEquipments().pipe(
          map((equipments) => EquipmentActions.loadEquipmentsSuccess({ equipments })),
          catchError((error) => of(EquipmentActions.loadEquipmentsFailure({ error })))
        )
      )
    )
  );

  addEquipment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EquipmentActions.addEquipment),
      mergeMap(({ equipment }) =>
        this.equipmentService.saveEquipment(equipment).pipe(
          map((savedEquipment) =>
            EquipmentActions.addEquipmentSuccess({ equipment: savedEquipment })
          ),
          catchError((error) => of(EquipmentActions.addEquipmentFailure({ error })))
        )
      )
    )
  );

  updateEquipment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EquipmentActions.updateEquipment),
      mergeMap(({ equipment }) =>
        this.equipmentService.saveEquipment(equipment).pipe(
          map((updatedEquipment) =>
            EquipmentActions.updateEquipmentSuccess({ equipment: updatedEquipment })
          ),
          catchError((error) => of(EquipmentActions.updateEquipmentFailure({ error })))
        )
      )
    )
  );

  deleteEquipment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EquipmentActions.deleteEquipment),
      mergeMap(({ id }) =>
        this.equipmentService.deleteEquipment(id).pipe(
          map(() => EquipmentActions.deleteEquipmentSuccess({ id })),
          catchError((error) => of(EquipmentActions.deleteEquipmentFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private equipmentService: EquipmentService
  ) {}
}
